<template>
    <master-layout>
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title"><i class="ti-bar-chart"></i> {{ $t('pipelines_report') }}</h4>
            </div>
            <pml-back-button></pml-back-button>
        </div>
        <div class="row">
            <div class="col-md-12">
                <PmlPipelineData v-for="item in pipelines" :key="item.id" :item="item"></PmlPipelineData>
            </div>
        </div>

        <!-- Empty Pipeline -->
        <div class="row" v-if="this.pipelines.length === 0">
            <div class="col-xs-12 col-sm-6">
                <div class="card-box">
                    <h4 class="header-title m-t-0 m-b-20 text-dark">{{$t('by_consultant')}}</h4>
                    <pml-ec-pizza></pml-ec-pizza>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6">
                <div class="card-box">
                    <h4 class="header-title m-t-0 m-b-20 text-dark">{{$t('by_pipeline_step')}}</h4>
                    <pml-ec-pizza></pml-ec-pizza>
                </div>
            </div>
        </div>

    </master-layout>
</template>

<script>
    import PmlPipelineData from './Pipeline.vue'
    import { mapGetters } from 'vuex'
    import { trans } from 'utils/helpers/translation'

    export default {
        name: 'PipelinesReport',
        metaInfo () {
            return {
                title: trans('pipelines_report')
            }
        },
        components: { PmlPipelineData },
        computed: {
            ...mapGetters({
                'pipelines': 'getPipelines'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/pipelines/components/Main.vue